import { createSelector } from "reselect";

import { PATH_TO_MEMORIES_STATE } from "../consts";
import MemoriesStateSlice from "../models/MemoriesStateSlice";
import { getMemoriesSlice } from "./state";
import * as memoriesSelectors from "./state/memories";
import * as memorySelectors from "./state/memories/memory";

type State = any;

export const getMemoriesStateSlice = (state: State): MemoriesStateSlice =>
  state.get(PATH_TO_MEMORIES_STATE);

const composedMemoriesSlice = (state: State) =>
  getMemoriesSlice(getMemoriesStateSlice(state));

export const getMemoriesMap = composedMemoriesSlice;

export const getMemoryForSection = (state: State, sectionId: string) =>
  memoriesSelectors.getMemoryForSection(
    composedMemoriesSlice(state),
    sectionId
  );

export const makeGetMemoriesForCourse = (courseId: string) =>
  createSelector(composedMemoriesSlice, memories =>
    memoriesSelectors.getMemoriesForCourse(memories, courseId)
  );

export const noMemoriesStored = (state: State) =>
  memoriesSelectors.noMemoriesStored(composedMemoriesSlice(state));

export const sectionHasMemory = (state: State, sectionId: string) =>
  memoriesSelectors.sectionHasMemory(composedMemoriesSlice(state), sectionId);

export const getMemoriesCount = (state: State) =>
  memoriesSelectors.getMemoriesCount(composedMemoriesSlice(state));

export const getMemories = (state: State) =>
  memoriesSelectors.getMemories(composedMemoriesSlice(state));

export const getAllMemoryLocationIds = (state: State) =>
  memoriesSelectors.getAllMemoryLocationIds(composedMemoriesSlice(state));

// memory selectors
export const getMemoryId = (state: State, sectionId: string) =>
  memorySelectors.getId(getMemoryForSection(state, sectionId)!);

export const getMemoryCourseId = (state: State, sectionId: string) =>
  memorySelectors.getCourseId(getMemoryForSection(state, sectionId)!);

export const getMemorySectionTitle = (state: State, sectionId: string) =>
  memorySelectors.getSectionTitle(getMemoryForSection(state, sectionId)!);

export const getMemoryLocationId = (state: State, sectionId: string) =>
  memorySelectors.getLocationId(getMemoryForSection(state, sectionId)!);

export const getMemoryTimeEarned = (state: State, sectionId: string) =>
  memorySelectors.getTimeEarned(getMemoryForSection(state, sectionId)!);
